import React from "react";
import { css, useTheme } from "@emotion/react";

import SocialsHorizontalList from "core/Components/Socials/SocialsHorizontalList";
import components from "elements/config/components";
import SocialsVerticalList from "core/Components/Socials/SocialsVerticalList";
import SectionContainer from "core/Components/SectionContainer";
import Wrapper from "core/Components/Wrapper";
import RelatedEvents from "pages/Components/OnlineEvent/components/RelatedEvents";

type Props = {
    data: OnlineEventPage,
};

/**
 * @param page
 * @constructor
 */
const OnlineEventPage: React.FC<Props> = ({ data: page }) => {
    const theme = useTheme();

    const style = css`
        display: flex;
        flex-direction: column;
        align-items: center;
    `;

    const socialShareDesktopStyle = css`
        position: absolute;
        top: 55px;
        right: 42px;

        ${theme.breakpoints.down('xl')} {
            display: none;
        }
    `;

    return (
        <SectionContainer>
            <Wrapper useMaxWidth={false} flexDirection={"column"}>
                {page?.elements && page.elements.map((ele: any, index: number) => {
                    let Component = Object.prototype.hasOwnProperty.call(components, ele.__typename) && components[ele.__typename];
                    if (ele.__typename === 'SegmentedVideo' && ele.segmentedVideoItems?.length === 0) {
                        return null;
                    }
                    return <Component data={ele} key={`${ele.id}-${index}`} />;
                })}

                <div css={style}>
                    <SocialsVerticalList
                        css={socialShareDesktopStyle}
                        emailSubject={"Online Event"}
                    />
                    <SocialsHorizontalList title={"Online Event"} />
                    <RelatedEvents relatedEvents={page.relatedEventPages} />
                </div>
            </Wrapper>
        </SectionContainer>
    );
};

export default OnlineEventPage;
